import React, { useState } from 'react';
import { ArrowUpRightIcon, ChevronDownIcon, GithubIcon, MenuIcon, XIcon } from 'lucide-react';
import { Wordmark } from './Wordmark';
import { projects } from '../data/site';
const navLinks = [{
  label: 'Blog',
  href: '#blog'
}, {
  label: 'About',
  href: '#about'
}];
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [osOpen, setOsOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-hairline bg-white/85 backdrop-blur" data-id="element-114" data-mp="uz0j6sll7gxs">
      <div className="mx-auto flex h-16 max-w-shell items-center gap-8 px-4 sm:px-8" data-id="element-115" data-mp="qxp075x7xtyk">
        <a href="#top" className="shrink-0" aria-label="VoidZero home" data-id="element-116" data-mp="14wopmfsk2cvs">
          <Wordmark data-id="element-117" data-mp="zxllcxkegaov" />
        </a>

        <nav aria-label="Main" className="hidden items-center gap-1 md:flex" data-id="element-118" data-mp="zwagsvj4qywp">
          <div className="relative" onMouseEnter={() => setOsOpen(true)} onMouseLeave={() => setOsOpen(false)} data-id="element-119" data-mp="2gb29zao3oa72">
            <button type="button" aria-expanded={osOpen} onClick={() => setOsOpen(v => !v)} className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-120" data-mp="2belbbmj9ydfq">
              Open Source
              <ChevronDownIcon className={`h-4 w-4 text-muted transition-transform duration-150 void-ease ${osOpen ? 'rotate-180' : ''}`} data-id="element-121" data-mp="2ogt243wgxva1" />
            </button>
            {osOpen && <div className="absolute left-0 top-full w-[340px] pt-2" data-id="element-122" data-mp="1vsov9f25vc5r">
                <ul className="overflow-hidden rounded-xl border border-hairline bg-white p-1.5 shadow-[0_16px_40px_-24px_rgba(11,11,12,0.35)]" data-id="element-123" data-mp="20qgwx0slycn5">
                  {projects.map(p => <li key={p.name} data-id="element-124" data-mp="183me08bfvlbs">
                      <a href={p.href} className="block rounded-lg px-3 py-2.5 transition-colors duration-150 void-ease hover:bg-void-soft" data-id="element-125" data-mp="182kstb0pligc">
                        <span className="font-mono text-[13px] text-void" data-id="element-126" data-mp="14z59red56qo4">{p.wordmark}</span>
                        <span className="mt-0.5 block text-[13px] leading-snug text-muted" data-id="element-127" data-mp="1002e2kj1xwst">
                          {p.tagline}
                        </span>
                      </a>
                    </li>)}
                </ul>
              </div>}
          </div>

          {navLinks.map(l => <a key={l.label} href={l.href} className="rounded-md px-3 py-2 text-sm text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-128" data-mp="h3iz3elkheoc">
              {l.label}
            </a>)}
          <a href="#void" className="flex items-center gap-1 rounded-md px-3 py-2 text-sm text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-129" data-mp="r3jl58atm8w8">
            Void
            <ArrowUpRightIcon className="h-3.5 w-3.5 text-muted" data-id="element-130" data-mp="2a04rcsgo5pxy" />
          </a>
        </nav>

        <div className="ml-auto hidden items-center gap-1 md:flex" data-id="element-131" data-mp="2a2hh3rso54lk">
          <a href="#github" aria-label="GitHub" className="grid h-9 w-9 place-items-center rounded-md text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-132" data-mp="2f0sqy2iyrf3s">
            <GithubIcon className="h-[18px] w-[18px]" data-id="element-133" data-mp="252v5tnwehyfe" />
          </a>
          <a href="#x" aria-label="X" className="grid h-9 w-9 place-items-center rounded-md text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-134" data-mp="2sr60g9bi71v8">
            <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-135" data-mp="2jy2flfyj3mqk">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-136" data-mp="2nycw3mjy5vjo" />
            </svg>
          </a>
          <a href="#discord" aria-label="Discord" className="grid h-9 w-9 place-items-center rounded-md text-ink transition-colors duration-150 void-ease hover:bg-black/[0.04]" data-id="element-137" data-mp="3gibfim9mdq4h">
            <svg viewBox="0 0 24 24" className="h-[18px] w-[18px] fill-current" aria-hidden="true" data-id="element-138" data-mp="1itprx163wqay">
              <path d="M20.317 4.369A19.79 19.79 0 0 0 15.446 3c-.21.375-.45.88-.617 1.276a18.27 18.27 0 0 0-5.487 0A12.6 12.6 0 0 0 8.72 3a19.74 19.74 0 0 0-4.873 1.37C.756 8.94-.08 13.395.34 17.787a19.9 19.9 0 0 0 5.993 3.04c.47-.64.888-1.32 1.246-2.035a12.9 12.9 0 0 1-1.962-.94c.165-.12.326-.246.48-.375 3.79 1.74 7.89 1.74 11.636 0 .157.13.317.255.48.375a12.9 12.9 0 0 1-1.965.94c.36.715.775 1.395 1.246 2.035a19.86 19.86 0 0 0 5.996-3.04c.5-5.09-.838-9.51-3.173-13.418ZM8.02 15.11c-1.17 0-2.13-1.08-2.13-2.41 0-1.33.94-2.41 2.13-2.41 1.2 0 2.16 1.09 2.14 2.41 0 1.33-.95 2.41-2.14 2.41Zm7.96 0c-1.17 0-2.13-1.08-2.13-2.41 0-1.33.94-2.41 2.13-2.41 1.2 0 2.16 1.09 2.14 2.41 0 1.33-.94 2.41-2.14 2.41Z" data-id="element-139" data-mp="1es48sy2zbfsb" />
            </svg>
          </a>
        </div>

        <button type="button" onClick={() => setMenuOpen(v => !v)} aria-expanded={menuOpen} aria-label="Toggle navigation" className="ml-auto grid h-10 w-10 place-items-center rounded-md border border-hairline text-ink md:hidden" data-id="element-140" data-mp="c12zmypgrcib">
          {menuOpen ? <XIcon className="h-4 w-4" data-id="element-141" data-mp="q0uhxbn0jf24" /> : <MenuIcon className="h-4 w-4" data-id="element-142" data-mp="uydywjb3i5xr" />}
        </button>
      </div>

      {menuOpen && <nav aria-label="Mobile" className="border-t border-hairline bg-white px-4 py-4 md:hidden" data-id="element-143" data-mp="uwjm5s9z9k4r">
          <p className="mb-2 font-mono text-[11px] uppercase tracking-[0.14em] text-muted" data-id="element-144" data-mp="zv4gjb2jt9la">
            open source
          </p>
          <ul className="mb-4 space-y-1" data-id="element-145" data-mp="18qapuk1129sk">
            {projects.map(p => <li key={p.name} data-id="element-146" data-mp="1dp42694kvur5">
                <a href={p.href} className="block py-1.5 font-mono text-sm text-void" data-id="element-147" data-mp="1dpwysh9tp3vk">
                  {p.wordmark}
                </a>
              </li>)}
          </ul>
          <ul className="space-y-1 border-t border-hairline pt-3" data-id="element-148" data-mp="3eqjyrm71fxd2">
            {[...navLinks, {
          label: 'Void',
          href: '#void'
        }].map(l => <li key={l.label} data-id="element-149" data-mp="39ttlt7qj5hvv">
                <a href={l.href} className="block py-1.5 text-sm text-ink" data-id="element-150" data-mp="3ogwmtoe2a8ny">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}